const prefix = 'permission';

const SET_PERMISSION = `${prefix}/SET_PERMISSION`;

// eslint-disable-next-line import/prefer-default-export
export { SET_PERMISSION };
